<template>
  <div class="xiazai-box" v-if="show" @click="show = false">
  	<div class="xiazai-box-model" @click.stop>
  		<div class="app-box-ewm">
  			<div class="app-box-ewm-item">
  				<div class="app-box-ewm-item-img">
  					<img :src="data.androidImg" alt="" />
  				</div>
  				<div class="app-box-ewm-item-des">{{$t('all.guojianzhuoxiazai')}}</div>
  				<div class="app-box-ewm-item-div">
  					<img src="../../assets/image/anzhuo.png" alt="" />
  					<div class="app-box-ewm-item-div-content">
  						<span class="app-box-ewm-item-div-content-span">GET IN ON</span>
  						<span class="app-box-ewm-item-div-content-span1">{{$t('all.anzhuoxiazai')}}</span>
  					</div>
  				</div>
  			</div>
  			<div class="app-box-ewm-item">
  				<div class="app-box-ewm-item-img">
  					<img :src="data.iosImg" alt="" />
  				</div>
  				<div class="app-box-ewm-item-des">{{$t('all.guojipingguoxiazai')}}</div>
  				<div class="app-box-ewm-item-div">
  					<img src="../../assets/image/pingguo.png" alt="" />
  					<div class="app-box-ewm-item-div-content">
  						<span class="app-box-ewm-item-div-content-span">Download on the</span>
  						<span class="app-box-ewm-item-div-content-span1">{{$t('all.pingguoxiazai')}}</span>
  					</div>
  				</div>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import { getAppDownloadConfig } from "@/api/user";
export default {
  data() {
    return {
	  show:false,
	  data:''
    };
  },
  mounted() {
	
  },
  methods: {
	showModel(data){
		this.show = true
		this.getAppDownloadConfig()
	},
	async getAppDownloadConfig(){
		const res = await getAppDownloadConfig()
		this.data = res.data
	}

  }
};
</script>
<style scoped lang="scss">
	@import "./xiazai.css";
</style>


// WEBPACK FOOTER //
// xiazai.vue?3a5a3364